import { useState } from 'react'

import LogoMobile from '../../assets/img/Galaktika_Logo_Mobile.png'
import Logo from '../../assets/img/logo-galaktika.png'
import Nav from '../navigation/Nav'

const Head = () => {
  const [isToggled, setIsToggled] = useState(false)

  return (
    <div
      className={
        !isToggled
          ? 'flex flex-col items-center pt-10 w-full relative'
          : 'nav-open flex flex-col items-center pt-10 w-full relative'
      }
    >
      <img
        className="hidden lg:block w-1/3 2xl:w-auto"
        alt="logo"
        src={Logo}
      ></img>
      <img
        className="block lg:hidden logo--mobile"
        alt="logo"
        src={LogoMobile}
      ></img>
      <div
        onClick={() => {
          setIsToggled(!isToggled)
        }}
        className="nav__toggle block lg:hidden hover:text-white text-cyanBlue transition-all duration-300 cursor-pointer absolute right-2 z-50"
      >
        <div className="hamburger"></div>
      </div>
      <Nav isToggled={isToggled} />
    </div>
  )
}

export default Head
